import React from "react";
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
// import { useStoreContext } from 'src/store/context';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

type LiveCatalogProps = {
  liveCatalog: any
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export const LiveCatalogDetailTab: React.FC<LiveCatalogProps> = ({ liveCatalog }) => {

  return (

    <Stack spacing={2} >
      <Item style={{ marginBottom: '10px', backgroundColor: 'rgba(245, 239, 239, 0.87)' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ marginBottom: '1rem', fontWeight: 700, fontSize: '20px', width: '48%', textAlign: 'left', color:'black' }}>Herbaceous</div>
          <div style={{ fontWeight: 700, fontSize: '20px', width: '48%', textAlign: 'left', color: 'black' }}>Woody</div>

        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <TableContainer component={Paper} sx={{ width: '48%' }}>
            <Table aria-label="simple table" sx={{ '& .MuiTableCell-root': { border: '1px solid rgba(224, 224, 224, 1)' } }}>
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <TableBody>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Temp Min Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbTempMinMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Temp Min Max</TableCell>
                  <TableCell align="left">{liveCatalog?.herbTempMinMax}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Day Length Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbDayLengthMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Day Length Max</TableCell>
                  <TableCell align="left">{liveCatalog?.herbDayLengthMax}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous VPD Avg Flag</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbVpdAvgFlg}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Days Avg</TableCell>
                  <TableCell align="left">{liveCatalog?.herbDaysAvg}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Max GSI</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbMaxGsi}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Greenup Threshold</TableCell>
                  <TableCell align="left">{liveCatalog?.herbGreenup}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous FM Max</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbMax}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous FM Min</TableCell>
                  <TableCell align="left">{liveCatalog?.herbMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Running Precip Total Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbPrecipTotalMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Running Precip Total Max</TableCell>
                  <TableCell align="left">{liveCatalog?.herbPrecipTotalMax}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Running Total Precip Days</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbTotalPrecipDays}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Herbaceous Use Precip Flag</TableCell>
                  <TableCell align="left">{liveCatalog?.herbUsePrecipFlg}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Herbaceous Calibration</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.herbCalibration === '1' ? 'On' : 'Off'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <TableContainer component={Paper} sx={{ width: '48%' }}>
            <Table aria-label="simple table" sx={{ '& .MuiTableCell-root': { border: '1px solid rgba(224, 224, 224, 1)' } }}>
              <colgroup>
                <col width="50%" />
                <col width="50%" />
              </colgroup>
              <TableBody>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Temp Min Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyTempMinMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Temp Min Max</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyTempMinMax}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Day Length Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyDayLengthMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Day Length Max</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyDayLengthMax}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody VPD Avg Flag</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyVpdAvgFlg}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Days Avg</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyDaysAvg}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Max GSI</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyMaxGsi}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Greenup Threshold</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyGreenup}</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody FM Max</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyMax}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody FM Min</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Running Precip Total Min</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyPrecipTotalMin}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Running Precip Total Max</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyPrecipTotalMax}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Running Total Precip Days</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyTotalPrecipDays}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell >Woody Use Precip Flag</TableCell>
                  <TableCell align="left">{liveCatalog?.woodyUsePrecipFlg}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }}>Woody Calibration</TableCell>
                  <TableCell style={{ backgroundColor: '#f2f2f5' }} align="left">{liveCatalog?.woodyCalibration==='1'?'On':'Off'}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Item>

    </Stack>
  );
}
